import { render, staticRenderFns } from "./Niches.vue?vue&type=template&id=2fccf770&scoped=true&"
import script from "./Niches.vue?vue&type=script&lang=js&"
export * from "./Niches.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=2fccf770&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fccf770",
  null
  
)

export default component.exports